import { SlideAction } from '@gripp/shared-ui';
import { useSlideLayoutSafe } from 'libs/shared-ui/src/components/slide-layout/SlideLayout';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { useLocation, useNavigate } from 'react-router-dom';

export const AssetRoutineSubmitHeader = ({
  assetId,
  routineId,
}: {
  assetId: string;
  routineId: string;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const slideLayout = useSlideLayoutSafe();

  const onEditButtonPress = async () => {
    if (slideLayout && !location.pathname.includes('/alerts/')) {
      await slideLayout.onSlideChange(SlideAction.NEXT);
    }

    navigate(`/assets/${assetId}/routines/${routineId}/alerts`, { state: location.state });
  }

  return (
    <View style={styles.filtersContainer}>
      <Pressable onPress={onEditButtonPress}>
        <Text style={styles.text}>{t('alerts.setAlert')}</Text>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 16,
  },
  text: {
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: '600',
  },
});
